import { render, staticRenderFns } from "./DetVoyageReviewMenu.vue?vue&type=template&id=a53b5a4c&"
import script from "./DetVoyageReviewMenu.vue?vue&type=script&lang=js&"
export * from "./DetVoyageReviewMenu.vue?vue&type=script&lang=js&"
import style0 from "./DetVoyageReviewMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetVoyageReviewMenu.vue"
export default component.exports